"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Base = void 0;
var renderer_1 = require("./renderer");
var camera_1 = require("./camera");
var util_1 = require("../util");
var three_1 = require("three");
var resource_1 = require("../resource");
var playground_1 = require("./playground");
var rotationLocked = false;
var loginStatus = false;
var Base = /** @class */ (function () {
    function Base(canvas, domCanvas, domBundle) {
        this.canvas = canvas;
        this.domCanvas = domCanvas;
        this.domBundle = domBundle;
        this.sizer = new util_1.Sizer(this.canvas);
        this.scene = new three_1.Scene();
        this.scene2 = new three_1.Scene();
        this.ticker = new util_1.Ticker();
        this.camera = new camera_1.Camera(this);
        this.renderer = new renderer_1.Renderer(this);
        this.playground = new playground_1.Playground(this);
        this.touched = false;
        this.touchedReactDelay = 2000;
        this.initResizeMechanic();
        this.initTickMechanic();
        this.initTouchMechanic();
    }
    Base.prototype.initResizeMechanic = function () {
        var _this = this;
        this.sizer.on('resize', function () {
            _this.renderer.resize();
            _this.camera.resize();
        });
    };
    Base.prototype.initTickMechanic = function () {
        var _this = this;
        this.ticker.on('tick', function (clock) {
            var delta = clock.getDelta();
            _this.renderer.update();
            _this.camera.update();
            _this.playground.update(delta);
        });
    };
    Base.prototype.initTouchMechanic = function () {
        var _this = this;
        var startLocation = new three_1.Vector2();
        var endLocation = new three_1.Vector2();
        var timeout;
        var cbStart = function (e) {
            startLocation.x = e.clientX;
            startLocation.y = e.clientY;
            _this.touched = true;
        };
        var cbEnd = function (e) {
            endLocation.x = e.clientX;
            endLocation.y = e.clientY;
            var delay = startLocation.distanceTo(endLocation) > 5 ? _this.touchedReactDelay : 0;
            clearTimeout(timeout);
            timeout = setTimeout(function () {
                _this.touched = false;
            }, delay);
        };
        this.domCanvas.addEventListener('mousedown', cbStart);
        this.domCanvas.addEventListener('touchstart', cbStart);
        this.domCanvas.addEventListener('mouseup', cbEnd);
        this.domCanvas.addEventListener('touchend', cbEnd);
        this.domCanvas.addEventListener('mouseleave', cbEnd);
    };
    Base.prototype.setRotationLock = function (status) {
        rotationLocked = status;
    };
    Base.prototype.getRotationLockStatus = function () {
        return rotationLocked;
    };
    Base.prototype.setLoginStatus = function (status) {
        loginStatus = status;
    };
    Base.prototype.getLoginStatus = function () {
        return loginStatus;
    };
    Base.prototype.getResources = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, (0, resource_1.getResources)()];
                    case 1:
                        _a.resources = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return Base;
}());
exports.Base = Base;
